import { createBlock } from 'factories/block';
import { InteractionProps, repeat } from './interaction';
import { createLayout } from 'factories/layout';
// import contentCard_default from 'assets/Card_default.svg';
import contentCard_default from 'assets/Card_Test.png';
import { colors } from 'styles/variables';
import { createMediaBlock } from './media';
import { Block, cloneBlock, Blocks } from '@chameleoncreator/creator-app';
import { flatten } from 'factories/utils';
import { createContinueBtn } from './continueBtn';
import Media_default from 'assets/Media_default.svg';
import { createEditableBtn } from './editableBtn';
import uuid from 'uuidv4';
import { getSId } from '../utils';

const { lPink, lGrey0, lGrey2, lTeal0 } = colors;

// export type ClickAndRevealInteractionProps = InteractionProps & {
//   answerCount: number;
// };

// - ClickAndReveals
//         - ClickAndReveal (repeat)
//            - Media
//              - Text
//              - Image
//              - Animation
//            -Feedback

const createContentCardBlock = props => {
  return createBlock('ContentCard', [
    createMediaBlock({
      src: undefined,
      child: 1,
      // fit: 'contain',
      fit: 'cover',
      useBackgroundControls: false,
    }),
    createBlock('Text', [], { props: { useBackgroundControls: true } }),
    createContinueBtn({
      label: 'Add navigation',
      removeable: false,
      disableLastPageMessage: true,
    }),
  ]);
};

export const createContentCardsBlock = (count: number) => {
  return createBlock('ContentCards', [
    ...repeat(() => createContentCardBlock({}), count),
  ]);
};

export const addContentCard = (
  block: Block,
  position: number
): [Block, Blocks?] => {
  // console.log(block.type);
  if (block.type === 'ContentCards') {
    const contentCardBlock = createContentCardBlock({});

    const contentCardBlockRef = { id: contentCardBlock.id, type: 'Ref' };
    const [newBlocks] = flatten(contentCardBlock);

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).splice(position, 0, contentCardBlockRef);

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};

export const removeContentCard = (
  block: Block,
  position: number
): [Block, Blocks?] => {
  if (block.type === 'ContentCards') {
    const contentCardBlock = createContentCardBlock({});

    const [newBlocks] = flatten(contentCardBlock);

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).splice(position, 1);

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};

const contentForColumn = (count: number) => (i: number) => {
  return [
    () => createBlock('Text', [], { props: { useBackgroundControls: true } }),
    () => createContentCardsBlock(count),
  ][i];
};

export const createContentCardInteractionBlock = props => {
  // console.log(props);

  const {
    grid = 'masonry',
    contentCardBackgroundColor = '#fff',
    contentCardPanelTextColor = lGrey0,
    contentCardContentTextColor = lGrey0,
    width = 33,
    height = 0,
    borderRadius = 20,
    outline = false,
    borderColor = lGrey0,
    imagePosition = 'top',
    includeText = true,
    includeShadow = true,
    uniformHeight = false,
    numColumns = 3,
    style,
  } = props as any;

  return createBlock(
    'Interaction',
    [
      createLayout(
        contentForColumn(props.numberOfCards),
        // props.columnCount,
        // props.columnsReversed
        0,
        true
      ),
      // createBlock('Modal', [createBlock('Text')]),
      createBlock('SingleColumnLayout', [
        createBlock(
          'Column',
          [
            // createBlock('ContinueButton', 'Continue' as any, {
            //   meta: { subType: 'continue' },
            // }),
            createContinueBtn(style),
          ],
          {
            props: {
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              flexWrap: 'wrap',
            },
            meta: {
              subType: 'ButtonBlock',
            },
          }
        ),
      ]),
    ],
    {
      props: {
        name: props.name,
        sId: getSId('interaction'),
        style: props.style,
        grid,
        contentCardBackgroundColor,
        contentCardPanelTextColor,
        contentCardContentTextColor,
        width,
        height,
        outline,
        borderRadius,
        borderColor,
        imagePosition,
        includeText,
        includeShadow,
        uniformHeight,
        numColumns,
      },
      meta: {
        subType: 'ContentCards',
        // layout: `${props.columnCount === 0 ? 'OneColumn' : 'TwoColumns'}${
        //   props.columnsReversed ? 'Reversed' : ''
        // }`,
        layout: 'OneColumn',
      },
    }
  );
};

export const create = createContentCardInteractionBlock;
export const interactionConfig = {};

export { contentCard_default };
